import { useOnboarding } from './OnboardingFlow'
import HelperAppDownload from '../HelperAppDownload'

export default function HelperAppStep() {
  const { nextStep } = useOnboarding()

  return (
    <div className="bg-white rounded-2xl shadow-xl p-8 sm:p-12">
      <HelperAppDownload onConnected={nextStep} />
      <div className="border-t mt-8 pt-4">
        <button
          onClick={nextStep}
          className="w-full py-3 border-2 border-gray-200 text-gray-700 rounded-xl font-medium hover:bg-gray-50 transition-colors"
        >
          Skip for Now
        </button>
      </div>
    </div>
  )
}
